import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Inspection } from "src/app/models/inspection.model";
import { RequestService } from "src/app/services/request/request.service";

@Injectable({
	providedIn: "root",
})
export class InspectionService {
	constructor(public requestService: RequestService) {}

	public getInspection(inspectionId: string, companyId: string, endpoint: string): Observable<Inspection> {
		return this.requestService.get<Inspection>({
			url: `${endpoint}/inspections/${inspectionId}?companyId=${companyId}`,
		});
	}
}
